/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2021-02-19 15:28:58
 * @LastEditors: yy
 * @LastEditTime: 2021-02-20 16:27:24
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './SelectIndustry.css';
import { getIndustryList } from '../../controller';


function deepList (list, onSelect) {
  if (Array.isArray(list) && list.length > 0) {
    return (
      <ul>
        {list.map(v => {
          return (
            <li key={v.id}>
              <div onClick={() => onSelect(v)}>{v.name}</div>
              {deepList(v.children, onSelect)}
            </li>
          )
        })}
      </ul>
    )
  }
  return null
}

class SelectIndustry extends React.Component {
  state = {
    list: [],
    name: '',
    visible: false
  }
  componentDidMount () {
    this.init()
    this.setState({
      name: this.props.defaultValue
    })
  }
  init = () => {
    getIndustryList().then(res => {
      console.log(res);
      this.setState({
        list: res.data
      })
    })
  }
  onSelect = (v) => {
    const onSelect = this.props.onSelect
    typeof onSelect === 'function' && onSelect(v) 
    this.setState({
      name: v.name
    })
  }
  onFocus = () => {
    this.setState({
      visible: true
    })
  }
  onBlur = () => {
    setTimeout(() => {
      this.setState({
        visible: false
      })
    }, 100);
  }
  render() {
    const {list, name, visible} = this.state
    return (
      <div className={s.root}>
        <input onFocus={this.onFocus} onBlur={this.onBlur} value={name} />
        <div className={s.selectBox} style={{display: visible ? 'block' : 'none'}}>
          {deepList(list, this.onSelect)}
        </div>
      </div>
    )
  }
}

export default withStyles(s)(SelectIndustry);



// WEBPACK FOOTER //
// src/components/SelectIndustry/SelectIndustry.js